document.addEventListener("DOMContentLoaded", function () {
  const swiperHero = document.querySelector(".swiper-hero");

  if (swiperHero) {
    const swiperParams = {
      slidesPerView: 1,
      loop: true,
      pagination: {
        clickable: true,
      },
      autoplay: {
        delay: 4000,
      },
    };

    Object.assign(swiperHero, swiperParams);
    swiperHero.initialize();
  }

  const swiperBlog = document.querySelector(".swiper-blog");

  if (swiperBlog) {
    const swiperParams = {
      slidesPerView: "auto",
      spaceBetween: 8,
      pagination: false,
      loop: false,
      autoplay: false,
    };

    Object.assign(swiperBlog, swiperParams);
    swiperBlog.initialize();
  }

  const brandNav = document.querySelector(".brand-mobile-nav");

  if (brandNav) {
    const swiperParams = {
      slidesPerView: "auto",
      spaceBetween: 8,
      pagination: false,
      loop: false,
      autoplay: false,
    };

    Object.assign(brandNav, swiperParams);
    brandNav.initialize();
  }

  const swiperBrand = document.querySelector(".brand-swiper");

  if (swiperBrand) {
    const swiperParams = {
      navigation: {
        nextEl: ".brand-swiper-button-next",
        prevEl: ".brand-swiper-button-prev",
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: true,
      breakpoints: {
        0: {
          slidesPerView: "auto",
          direction: "vertical",
          spaceBetween: 32,
          enabled: false,
          allowTouchMove: true,
        },
        1024: {
          direction: "horizontal",
          slidesPerView: 1.4,
          spaceBetween: 116,
          loop: false,
          pagination: {
            clickable: true,
          },
          autoplay: false,
          enabled: true,
        },
        1400: {
          direction: "horizontal",
          slidesPerView: 2,
          spaceBetween: 116,
          loop: false,
          pagination: {
            clickable: true,
          },
          autoplay: false,
          enabled: true,
        },
      },
    };

    Object.assign(swiperBrand, swiperParams);
    swiperBrand.initialize();
  }

  const swiperThumbsElement = document.querySelector(".swiper-thumbs");
  const swiperProductElement = document.querySelector(".swiper-product");

  if (swiperThumbsElement) {
    const swiperThumbsParams = {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    };

    Object.assign(swiperThumbsElement, swiperThumbsParams);
    swiperThumbsElement.initialize();
  }

  if (swiperProductElement) {
    const swiperProductParams = {
      slidesPerView: 1,
      navigation: {
        nextEl: ".product-img-next",
        prevEl: ".product-img-prev",
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: swiperThumbsElement,
      },
      breakpoints: {
        768: {
          pagination: false,
        },
      },
    };

    Object.assign(swiperProductElement, swiperProductParams);
    swiperProductElement.initialize();
  }

  const swiperProducts = document.querySelector(".products-swiper");

  if (swiperProducts) {
    const swiperParams = {
      slidesPerView: 2,
      spaceBetween: 8,
      loop: true,
      pagination: false,
      autoplay: false,
      centerInsufficientSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    };

    Object.assign(swiperProducts, swiperParams);
    swiperProducts.initialize();
  }

  const swiperMedias = document.querySelector(".medias-swiper");

  if (swiperMedias) {
    const swiperParams = {
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        nextEl: ".media-swiper-button-next",
        prevEl: ".media-swiper-button-prev",
      },
      breakpoints: {
        1024: {
          spaceBetween: 16,
        },
      },
    };

    Object.assign(swiperMedias, swiperParams);
    swiperMedias.initialize();
  }

  const swiperArticles = document.querySelector(".related-articles-swiper");

  if (swiperArticles) {
    const swiperParams = {
      spaceBetween: 8,
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".related-articles-next",
        prevEl: ".related-articles-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1400: {
          spaceBetween: 16,
          slidesPerView: 4,
        },
      },
    };

    Object.assign(swiperArticles, swiperParams);
    swiperArticles.initialize();
  }

  const swiperEls = document.querySelectorAll(".cards-swiper");

  swiperEls.forEach((swiperEl) => {
    Object.assign(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 12,
      autoHeight: true,
      pagination: false,
      breakpoints: {
        768: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
    swiperEl.initialize();
  });
});
